import React from 'react';
import CardForm from './components/CardForm';
// import EnvTest from './components/EnvTest'; // Đã test OK, có thể bỏ comment để debug
import './App.css';

function App() {
  return (
    <div className="App">
      {/* <EnvTest /> */}
      <CardForm />
    </div>
  );
}

export default App;
